export default __webpack_public_path__ + "static/media/male_user.33767587.png";